// The one mapper from `GET /api/auth/me`'s body to the session's user (BL-2343): shared by the
// session refresh and the phone app's offline session, which reads the same route offline.
import type { SessionUserDto } from '@auctogon/core-admin/schemas/responses/session';

/**
 * Map the non-standard `/api/auth/me` payload (`{ user }` at top level) to the session's user
 * shape.
 *
 * @param data - the parsed body (`AuthMeResponseBody`, read loosely: it arrives as JSON).
 * @returns the user, or null for the unauthenticated / no-user response.
 */
export function mapMeResponse(data: { user?: Partial<SessionUserDto> | null }): SessionUserDto | null {
    const u = data.user;
    if (!u) return null;
    return {
        id: u.id as string,
        email: u.email as string,
        // BUG-1650: the server already resolved this from the name parts, so
        // the client takes it verbatim. The `|| u.email` that used to sit here
        // was the client half of the same email-for-a-name substitution — and
        // it disagreed with what My Profile and the Team list each showed.
        name: u.name as string,
        tenantRoles: u.tenantRoles ?? {},
        isSuperAdmin: u.isSuperAdmin ?? false,
    };
}
